import classes from "./NavBarComponent.module.css";
import { useSelector, useDispatch } from "react-redux";
import { FaBars, FaBell, FaEnvelope } from "react-icons/fa6";
import { toggleSideMenuVisibility } from "../../store/ui-slice";
import { useLocation } from "react-router-dom";
import ButtonAvatar from "../components/buttons/ButtonAvatar";
import ButtonIcon from "../components/buttons/ButtonIcon";
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { Dropdown } from "primereact/dropdown";

const NavBarComponent = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const pathSegments = location.pathname.split("/");
  const lastPathSegment = pathSegments[pathSegments.length - 1];

  const bcHome = { icon: "pi pi-home", url: "/" };

  const handleHamburger = (e) => {
    dispatch(toggleSideMenuVisibility());
  };

  // const location = useLocation();
  // const pathSegments = location.pathname.split("/");
  // const lastPathSegment = pathSegments[pathSegments.length - 1];

  // const refineTitle = (rawTitle) => {
  //   let titleLabel = lastPathSegment.replace("-", " ");
  //   titleLabel = titleLabel.replace(/\w\S*/g, function (txt) {
  //     return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  //   });

  //   return titleLabel;
  // };

  // const title = refineTitle(lastPathSegment);
  const title = useSelector((state) => state.ui.layoutDashboardTitle);

  const handleDefaultAvatarClick = (e) => {
    console.log("Handle Avatar Click");
  };
  const handleAvatarClick = props.onCLickAvatar || handleDefaultAvatarClick;

  const handleDefaultNotifClick = (e) => {
    console.log("Handle Notif Click");
  };
  const handleNotifClick = props.onClickNotif || handleDefaultNotifClick;

  return (
    <nav className={`${classes.wrapper} row-between-center ps-3 pe-3 w-100`}>
      <div className={`row-start-center gap-3`}>
        <div
          className={`${classes.hamburgerButton} row-center-center`}
          onClick={handleHamburger}
        >
          <FaBars />
        </div>
        <div className={`${classes.title} row-start-center`}>{title}</div>
      </div>
      <div className="row-end-center gap-2">
        {props.showNotif && (
          <ButtonIcon icon={<FaBell />} onClick={handleNotifClick} />
        )}
        <ButtonAvatar onClick={handleAvatarClick} src={props.avatarSrc} />
      </div>
    </nav>
  );
};

export default NavBarComponent;
